import { SubCategoryDetails } from '@/@types';
import { SubCategoryDetailsResponse } from '../../partsServices/models/PartsServicesResponse';

export function mapSubCategoryDetails(subCategory: SubCategoryDetailsResponse): SubCategoryDetails {

    return {
        name: subCategory.name,
        description: subCategory.description,
        media: subCategory.media,
        content: subCategory.content,
        slug: subCategory.slug,
        subtitle: subCategory.subtitle,
        meta_title: subCategory.meta_title,
        meta_description: subCategory.meta_description,
        meta_keywords: subCategory.meta_keywords,
    }
}